// extracted by mini-css-extract-plugin
export default {"button":"brand-button_button__lwYFP","label":"brand-button_label__N4zOi","spinner":"brand-button_spinner__UQV9C","spin":"brand-button_spin__uF9QE"};